export default __webpack_public_path__ + "static/1313-9f6a2765ed8e653e9642f205bafef7a2.gif";